<template>
  <span
    :class="[`material-symbols-${type}`, { 'icon-ready': fontLoaded }]"
    :style="computedStyle"
    data-testid="icon-google"
    @click="$emit('click', $event)"
  >{{ name }}</span>
</template>

<script lang="ts" setup>
import { computed, ref, onMounted } from 'vue'

defineEmits<{ click: [event: MouseEvent] }>()

const props = withDefaults(defineProps<{
  name: string
  type?: 'outlined' | 'rounded' | 'sharp'
  size?: string
  color?: string
  fill?: boolean
  weight?: number
  grade?: number
}>(), {
  type: 'outlined',
  size: '1.3rem',
  color: 'var(--fontcolor)',
  fill: false,
  weight: 400,
  grade: 0,
})

const fontLoaded = ref(false)

onMounted(async () => {
  try {
    await document.fonts.ready
    fontLoaded.value = true
  } catch {
    fontLoaded.value = true
  }
})

const computedStyle = computed(() => ({
  fontSize: props.size,
  color: props.color,
  fontVariationSettings: `'FILL' ${props.fill ? 1 : 0}, 'wght' ${props.weight}, 'GRAD' ${props.grade}, 'opsz' 24`,
}))

defineExpose({ computedStyle })
</script>

<style scoped>
span {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-style: normal;
  line-height: 1;
  letter-spacing: normal;
  text-transform: none;
  white-space: nowrap;
  -webkit-font-smoothing: antialiased;
  user-select: none;
  min-width: 1em;
  min-height: 1em;
}

span:not(.icon-ready) {
  font-size: 0 !important;
  min-width: v-bind(size);
  min-height: v-bind(size);
}
</style>
